module.exports = __webpack_public_path__ + "img/Pagenotfound_illu.7da8d139.svg";